import { render, staticRenderFns } from "./scope-mask.vue?vue&type=template&id=4acac9e0&scoped=true&"
import script from "./scope-mask.vue?vue&type=script&lang=ts&"
export * from "./scope-mask.vue?vue&type=script&lang=ts&"
import style0 from "./scope-mask.vue?vue&type=style&index=0&id=4acac9e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acac9e0",
  null
  
)

export default component.exports